import client from '@/api/client';
import { BASE_URL } from '@/constants';
import { objectToQueryString } from '@/utils/sfaas_temp';

export default {
	async getList({ searchParams, currentPage, pageUnit }) {
		const queryStr = objectToQueryString({
			strMt: searchParams.strMt,
			currentPage,
			pageUnit
		});
		try {
			const response = await client.get(`${BASE_URL}/pqy/pcku/overSrgCpr/v1/overSrgCprs${queryStr}`);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	}
};
